import App from './AppV3.svelte';

import {InitAnalytics} from "./analitics/analytics";
import {manageGlobalError} from "./misc/ErrorCatching";
InitAnalytics();

manageGlobalError();

const app = new App({
	target: document.body,
	props: {
		name: 'world',
	}
});



export default app;
